import { Component, computed, input, output } from '@angular/core';
import { PriceCurveEntry } from '../../../../core/clients/omni-core/models';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { LoadingSpinner } from 'excellence-ui';
import { DatePipe } from '@angular/common';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { PriceFilter } from '../../stores/price.store';
import { ConvertPricePipe } from '../../pipes/convert-price-pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-analysis-price-table',
  templateUrl: './analysis-price-table.html',
  imports: [
    ErrorComponent,
    LoadingSpinner,
    DatePipe,
    GermanNumberPipe,
    ConvertPricePipe,
    TranslocoPipe,
  ],
})
export class AnalysisPriceTable {
  prices = input.required<PriceCurveEntry[]>();
  granularity = input.required<PriceFilter['granularity']>();
  showEurMwh = input.required<boolean>();
  loading = input.required<boolean>();
  error = input.required<unknown>();

  clickReload = output();

  protected unitKey = computed(() =>
    this.showEurMwh()
      ? 'cockpit.analysis.hpfc.detail.yAxisLabelEurMwh'
      : 'cockpit.analysis.hpfc.detail.yAxisLabel',
  );
}
